export const ar = {
	afkar: "أفكار",
	location: "الموقع",
	"Media Center": "مركز الاعلام",
	"Our Projects": "مشاريعنا",
	"home page": "الصفحه الرئيسيه",
	"Discover Who We Are": "اكتشف من نحن",
	"Who We Are": "من نحن",
	home: "الصفحه الرئيسيه",
	Products: "المنتجات",
	Subject: "موضوع",
	Projects: "المشاريع",
	Employees: "الموظفون",
	Countries: "الدول",
	Continents: "القارات",
	"Read More": "اقرأ المزيد",
	"Our Board": "مجلس إدارتنا",
	"Our Leadership Team": "فريق قيادتنا",
	"Our News": "اخبارنا",
	"JOIN US": "انضم إلينا",
	"Image Gallery": "معرض الصور",
	"View on Google Maps": "عرض على خرائط جوجل",
	"Chat to Sales": "دردش مع المبيعات",
	"Chat to Support": "دردش مع الدعم",
	"Visit Us": "تفضل بزيارتنا",
	"Call Us": "اتصل بنا",
	"Visit our office HQ": "تفضل بزيارة مقرنا الرئيسي",
	"We’re here to help": "نحن هنا لمساعدتك",
	"Speak to our friendly team": "تحدث مع فريقنا الودود",
	categories: "الأقسام",
	"Forward your Resume to": "أرسل سيرتك الذاتية إلى",
	Careers: "الوظائف",
	"about-us": "من نحن",
	"Our Project": "مشاريعنا",
	"Privcy Policy": "سياسة الخصوصية",
	"term & conditions": "الشروط والأحكام",
	from: "من",
	to: "إلي",
	quick_links: "روابط سريعة",
	Brand: "ماركة",
	"Shop By Category": "تسوق حسب القسم",
	"View All": "عرض الكل",
	All: "الكل",
	previous: "السابق",
	Description: "وصف",
	"filter by": "تصفية حسب",
	"Dynamic Variant": "اضافات بسعر",
	"Similar Products": "منتجات مماثلة",
	next: "التالي",
	"Cancel Message":
		"هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء، وسيتم فقد أي تقدم متعلق بالطلب.",
	results: "نتائج",
	"Explore All": "استكشاف الكل",
	Explore: "استكشف",
	"more Details": "المزيد من التفاصيل",
	"Feature Products": "المنتجات المميزة",
	QUALITY: "الجودة التي يقدمها لك MASTER HN",
	"Best Selling Products": "أفضل المنتجات مبيعا",
	"Featured Products": "المنتجات المميزة",
	"There's no Products": "لا يوجد منتجات",
	"Working Hours": "ساعات العمل",
	"ordered successfully": "شكرًا لك على طلبك",
	"ordered successfully description": "تم تقديم طلبك بنجاح",
	"ordered failed": "حدث خطأ ما!",
	"ordered failed description": "لم يتم استكمال الدفع",
	Cancel: "إلغاء",
	"Cash in Delivery": "نقدا عند التسليم",
	canceled: "تم الإلغاء",
	"out of stock": "نفذ من المخزن",
	"Working Days": "أيام العمل",
	"Show Rooms": "صالات العرض",
	"Best seller": "الأكثر مبيعًا",
	Offers: "العروض",
	branches: "الفروع",
	brands: "العلامات التجارية",
	Contacts: "جهات الاتصال",
	"Follow us": "تابعنا",
	"New Arrivals": "المنتجات الجديدة",
	"DOWNLOAD MASTER HN": "تحميل Master HN",
	"Style Up Your Looks": "صمم مطبخك",
	"All Rights": "كل الحقوق محفوظة",
	"Hasan Al Naser": "حسن الناصر",
	"Powered By": "مدعوم من",
	"Total Price": "السعر الإجمالي",
	Continue: "متابعة",
	"Your Cart is Empty": "عربة التسوق فارغة",
	KWD: "د.ك",
	"Download Pdf": "تحميل الملف",
	"Style Up": "صمم",
	"Add To Cart": "أضف إلى السلة",
	contact: "اتصل بنا",
	Name: "الإسم",
	Email: "البريد الإلكتروني",
	Phone: "رقم الموبايل",
	Message: "الرسالة",
	"contact us": "تواصل معنا",
	"CONTACT US ON WHATSAPP": "تواصل معنا عبر واتساب",
	"GET IN TOUCH": "ابق على تواصل",
	Product: "المنتج",
	Price: "السعر",
	Quantity: "الكمية",
	Total: "الإجمالي",
	subcategory: "الفئة الفرعية",
	"term and conditions": "الشروط والأحكام",
	privacy: "الخصوصية",
	"Sub Total": "المجموع الفرعي",
	Payment: "الدفع",
	"Payment Details": "تفاصيل الدفع",
	Proceed: "هل ترغب في المتابعة لإتمام الطلب كـ",
	Login: "تسجيل الدخول",
	"Continue as a Guest": "المتابعة كزائر",
	"Login Into Your Account": "تسجيل الدخول إلى حسابك",
	"Create New Account": "إنشاء حساب جديد",
	Password: "الرقم السري",
	"Don't Have Account": "ليس لديك حساب",
	"Sign Up": "التسجيل",
	"Have Account": "لديك حساب",
	Checkout: "إتمام الشراء",
	"User Details": "تفاصيل المستخدم",
	"Full Name": "الاسم الكامل",
	"Address Details": "تفاصيل العنوان",
	Area: "المنطقة",
	Block: "البلوك",
	Street: "الشارع",
	Avenue: "الجادة",
	"Floor Number": "رقم الطابق",
	Optional: "اختياري",
	"Address Type": "نوع العنوان",
	"Building Number": "رقم المبنى",
	Floor: "الطابق",
	"Apartment Number": "رقم الشقة",
	"House Number": "رقم المنزل",
	"Office Number": "رقم المكتب",
	"Extra Directions": "اتجاهات إضافية",
	"Other Instructions": "تعليمات أخرى",
	"Please Enter": "الرجاء إدخال",
	"Please Select": "الرجاء التحديد",
	House: "المنزل",
	Flat: "شقه",
	Office: "المكتب",
	"Coupon Code": "رمز الكوبون",
	Apply: "تطبيق",
	"Payment Method": "طريقة الدفع",
	KNET: "كي نت",
	"Visa/MasterCard": "فيزا/ماستركارد",
	"Payment Detail": "تفاصيل الدفع",
	Discount: "الخصم",
	"Delivery Charges": "رسوم التوصيل",
	"Submit Order": "ارسال الطلب",
	"show some love to your bag": "أظهر بعض الحب لحقيبتك",
	"Fill your bag with things that make you happy":
		"املأ حقيبتك بالأشياء التي تسعدك",
	Profile: "الصفحه الشخصيه",
	Logout: "تسجيل الخروج",
	"My Account": "حسابي",
	"My Orders": "طلباتي",
	"Update Account": "تحديث الحساب",
	Update: "تحديث",
	"Change Password": "تغيير كلمة المرور",
	"New Password": "كلمة المرور الجديدة",
	"Old Password": "كلمة المرور القديمه",
	"Confirm New Password": "تأكيد كلمة المرور الجديدة",
	"This Field is required": "هذه الخانة مطلوبه",
	Amount: "كميه",
	Add: "إضافة",
	"Buy it again": "اشتري مره أخري",
	"Add Address First": "اضف العنوان اولا",
	"There are No Products": "لا يوجد منتجات",
	"Product Added To Cart": "تم إضافة المنتج إلى سلة التسوق",
	"Forget Password?": "هل نسيت كلمه المرور؟",
	Default: "الافتراضية",
	"Forget Password": "نسيت كلمه المرور",
	Back: "الي الخلف",
	Delete: "حذف",
	"Address Added Successfully.": "تمت إضافة العنوان بنجاح.",
	"Address Updated Successfully.": "تمت تعديل العنوان بنجاح.",
	"Address Deleted Successfully.": "تمت حذف العنوان بنجاح.",
	"Message Sent Successfully.": "تم إرسال الرسالة بنجاح.",
	"First Name": "الاسم الأول",
	"Last Name": "اسم العائلة",
	"Message Required": "الرسالة المطلوبة",
	"promo code is invalid!": "الرمز الترويجي غير صالح!",
	"Successfully Applied": "تم التطبيق بنجاح",
	"Remove from Cart": "إزالة من السلة",
	Remove: "إزاله",
	Search: "بحث",
	"Classic kitchen": "مطبخ كلاسيكي",
	"Modern kitchen": "المطبخ الحديث",
	"No Address": "لا يوجد عنوان",
	"Add New Address": "إضافة عنوان جديد",
	"Set Default": "تعيين كافتراضي",
	Edit: "تعديل",
};
